import appointmentApi from "@/api/Methods/Appointment-API-Methods";
import articleApi from "@/api/Methods/Article-API-Methods";
import checklistApi from "@/api/Methods/CheckList-API-Methods";
import contractApi from "@/api/Methods/Contract-API-Methods";
import counterApi from "@/api/Methods/Counter-API-Methods";
import customerApi from "@/api/Methods/Customer/Customer-API-Methods";
import departmentApi from "@/api/Methods/Department-API-Methods";
import documentApi from "@/api/Methods/Document-API-Methods";
import exportApi from "@/api/Methods/Export-API-Methods";
import firmApi from "@/api/Methods/Firm-API-Methods";
import jobCategoryApi from "@/api/Methods/Job-Category-API-Methods";
import jobApi from "@/api/Methods/Job/Job-API-Methods";
import kpiApi from "@/api/Methods/Kpi/KPI-API-Methods";
import leadApi from "@/api/Methods/Lead/Lead-API-Methods";
import loggApi from "@/api/Methods/Logg-API-Methods";
import assetTypeApi from "@/api/Methods/Machine/Asset-Type-API-Methods";
import commonPartsApi from "@/api/Methods/Machine/Common-Parts-API-Methods";
import machineApi from "@/api/Methods/Machine/Machine-API-Methods";
import modelApi from "@/api/Methods/Machine/Machine-Model-API-Methods";
import machineTypeApi from "@/api/Methods/Machine/Machine-Type-API-Methods";
import serviceAgreementApi from "@/api/Methods/Machine/Service-Agreement-API-Methods";
import supplierApi from "@/api/Methods/Machine/Supplier-API-Methods";
import mapsApi from "@/api/Methods/Maps-API-Methods";
import invoiceApi from "@/api/Methods/Order/Invoice-API-Methods";
import orderApi from "@/api/Methods/Order/Order-API-Methods";
import partApi from "@/api/Methods/Part-API-Methods";
import partnerCompanyApi from "@/api/Methods/Partner-Company-API-Methods";
import projectApi from "@/api/Methods/Project-API-Methods";
import qrCodeApi from "@/api/Methods/Qr-API-Methods";
import repairCodeApi from "@/api/Methods/Repair-Code-API-Methods";
import repairPlaceApi from "@/api/Methods/Repair-Place-API-Methods";
import settingsApi from "@/api/Methods/Settings-API-Methods";
import supplierFailureCodeApi from "@/api/Methods/Supplier-Failure-Code-API-Methods";
import taskManagerApi from "@/api/Methods/TaskManager-API-Methods";
import ticketApi from "@/api/Methods/Ticket-API-Methods";
import timeApi from "@/api/Methods/Time-API-Methods";
import userApi from "@/api/Methods/User/User-API-Methods";
import warrantytypeApi from "@/api/Methods/Warranty-Type-API-Methods";

export default {
    methods: {
        isValidId(id) {
            var result = /^[0-9]*$/.test(id);
            return result;
        },
        isValidDate(date) {
            if (Object.prototype.toString.call(date) === "[object Date]") {
                return true;
            } else {
                return false;
            }
        },
        ...articleApi.methods,
        ...customerApi.methods,
        ...jobApi.methods,
        ...machineApi.methods,
        ...modelApi.methods,
        ...machineTypeApi.methods,
        ...assetTypeApi.methods,
        ...appointmentApi.methods,
        ...documentApi.methods,
        ...loggApi.methods,
        ...orderApi.methods,
        ...invoiceApi.methods,
        ...userApi.methods,
        ...settingsApi.methods,
        ...departmentApi.methods,
        ...counterApi.methods,
        ...ticketApi.methods,
        ...kpiApi.methods,
        ...contractApi.methods,
        ...partApi.methods,
        ...timeApi.methods,
        ...leadApi.methods,
        ...repairCodeApi.methods,
        ...supplierApi.methods,
        ...serviceAgreementApi.methods,
        ...supplierFailureCodeApi.methods,
        ...qrCodeApi.methods,
        ...taskManagerApi.methods,
        ...checklistApi.methods,
        ...firmApi.methods,
        ...warrantytypeApi.methods,
        ...repairPlaceApi.methods,
        ...partnerCompanyApi.methods,
        ...commonPartsApi.methods,
        ...mapsApi.methods,
        ...projectApi.methods,
        ...exportApi.methods,
        ...jobCategoryApi.methods,
    }
};
